import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from 'transfix-ui/components/Table'
import { IEdiMessage, Maybe } from 'types/graphqlTypes'
import { Spinner } from 'transfix-ui'
import { useEdiMessageType } from '../../ConnectionConfigs/EdiRoutingTable/hooks/useEdiMessageType'
import { formatOptionLabel } from '../../EdiSelfServiceOutbound/hooks/useTransactionSets/utils/formatOptionLabel'

interface IIntegrationOverviewProps {
  outboundConfigIds: Maybe<string | string[]>
  inboundConfigIds: Maybe<string | string[]>
}

const getUniqueMessageTypes = (
  outboundEdiMessageTypes: IEdiMessage[],
  inboundEdiMessageTypes: IEdiMessage[]
) => {
  let messageTypes: IEdiMessage[] = []
  messageTypes = messageTypes.concat(...outboundEdiMessageTypes)
  messageTypes = messageTypes.concat(...inboundEdiMessageTypes)

  const formattedEdiMessageTypes = messageTypes.map(file =>
    formatOptionLabel({
      transactionSet: file.transactionSet,
      transactionSetSubtype: file.transactionSetSubtype,
    })
  )

  return [...new Set(formattedEdiMessageTypes)]
}

const getConfigGroups = (outboundEdiMessageTypes: IEdiMessage[]) => {
  const configGroups = outboundEdiMessageTypes.map(
    messageType => messageType.ediMapperConfigGroup?.name
  )
  return [...new Set(configGroups)]
}

export function IntegrationOverview({
  inboundConfigIds,
  outboundConfigIds,
}: IIntegrationOverviewProps) {
  const {
    ediMessageTypes: outboundEdiMessageTypes,
    loading: outboundMessageTypeLoading,
  } = useEdiMessageType({
    connectionConfigType: 'OutboundConnectionConfig',
    connectionConfigIds: outboundConfigIds,
  })

  const {
    ediMessageTypes: inboundEdiMessageTypes,
    loading: inboundMessageTypeLoading,
  } = useEdiMessageType({
    connectionConfigType: 'InboundConnectionConfig',
    connectionConfigIds: inboundConfigIds,
  })

  const uniqueMessageTypes = getUniqueMessageTypes(
    outboundEdiMessageTypes,
    inboundEdiMessageTypes
  ).join(', ')

  const configGroups = getConfigGroups(outboundEdiMessageTypes)

  return (
    <>
      {(inboundMessageTypeLoading || outboundMessageTypeLoading) && <Spinner />}
      <Table dataTest='OverviewTable'>
        <TableHead>
          <TableRow tableCellType='th'>
            <TableCell>Files Supported</TableCell>
            <TableCell>Config Groups</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableCell dataTest='overview-files'>{uniqueMessageTypes || 'None'}</TableCell>
          <TableCell dataTest='config-groups'>{configGroups || 'None'}</TableCell>
        </TableBody>
      </Table>
    </>
  )
}
